(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pk-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pkcardQuickAdd) return; window.__pkcardQuickAdd = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var hideBubble = null;

    function addToCart(id) {
      // XMLHttpRequest on purpose: the cart drawer watches fetch(/cart/add) and would pop open
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', root + 'cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = function () { if (xhr.status >= 200 && xhr.status < 300) resolve(); else reject(xhr); };
        xhr.onerror = function () { reject(xhr); };
        xhr.send(JSON.stringify({ items: [{ id: id, quantity: 1 }] }));
      });
    }

    function refreshCartCount() {
      // Tells the header cart icon (and the cart drawer contents) that the cart changed
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'pkcard', data: { itemCount: cart.item_count, source: 'pkcard' } }
          }));
        })
        .catch(function () {});
    }

    function findCartIcon() {
      var selectors = [
        'header a[href$="/cart"]',
        'header [aria-controls="cart-drawer"]',
        '[aria-controls="cart-drawer"]',
        'cart-icon',
        'a[href$="/cart"]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var els = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < els.length; j++) {
          var r = els[j].getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return els[j];
        }
      }
      return null;
    }

    function flyToCart(fromEl, color, onLand) {
      var land = function () { if (typeof onLand === 'function') onLand(); };
      var target = findCartIcon();
      var pop = function () {
        if (!target) return;
        target.animate(
          [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }],
          { duration: 450, easing: 'ease-out' }
        );
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { pop(); land(); return; }

      var from = fromEl.getBoundingClientRect();
      var sx = from.left + from.width / 2;
      var sy = from.top + from.height / 2;
      var ex = window.innerWidth - 32;
      var ey = 24; // header hidden on scroll: fly to the top-right corner
      if (target) {
        var t = target.getBoundingClientRect();
        ex = t.left + t.width / 2;
        ey = t.top + t.height / 2;
      }
      var cx = (sx + ex) / 2;
      var cy = Math.min(sy, ey) - 120;
      var size = 28;

      // Points along a curved path from the button to the cart icon
      var frames = [];
      var steps = 14;
      for (var i = 0; i <= steps; i++) {
        var p = i / steps;
        var x = (1 - p) * (1 - p) * sx + 2 * (1 - p) * p * cx + p * p * ex;
        var y = (1 - p) * (1 - p) * sy + 2 * (1 - p) * p * cy + p * p * ey;
        var scale = 1 - p * 0.65;
        frames.push({ transform: 'translate(' + (x - size / 2) + 'px, ' + (y - size / 2) + 'px) scale(' + scale + ')' });
      }

      var dot = document.createElement('span');
      dot.className = 'pkcard-fly-dot';
      dot.style.background = color;
      document.body.appendChild(dot);

      var anim = dot.animate(frames, { duration: 750, easing: 'ease-in-out' });
      anim.onfinish = function () { dot.remove(); pop(); land(); };
      anim.oncancel = function () { dot.remove(); land(); };
    }

    function showAddedBubble(info) {
      if (hideBubble) hideBubble();

      var bubble = document.createElement('div');
      bubble.className = 'pkcard-added';
      bubble.setAttribute('role', 'status');
      bubble.setAttribute('aria-live', 'polite');
      if (info.soft) bubble.style.setProperty('--pkcard-added-soft', info.soft);
      bubble.innerHTML =
        '<p class="pkcard-added__ok"><svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M6.3 10.3l2.4 2.4 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Added to your bag</span></p>' +
        '<div class="pkcard-added__row"><span class="pkcard-added__img"></span>' +
        '<div class="pkcard-added__body"><p class="pkcard-added__title"></p><p class="pkcard-added__meta"></p></div>' +
        '<span class="pkcard-added__price"></span></div>';
      bubble.querySelector('.pkcard-added__title').textContent = info.title;
      bubble.querySelector('.pkcard-added__meta').textContent = info.meta;
      bubble.querySelector('.pkcard-added__price').textContent = info.price;
      if (info.image) {
        var img = new Image(48, 48);
        img.src = info.image;
        img.alt = '';
        bubble.querySelector('.pkcard-added__img').appendChild(img);
      }
      document.body.appendChild(bubble);

      // Place the bubble under the cart icon, with the arrow pointing at the icon
      var icon = findCartIcon();
      var top = 12;
      var right = 12;
      var arrow = 16;
      if (icon) {
        var r = icon.getBoundingClientRect();
        top = r.bottom + 12;
        right = Math.max(12, window.innerWidth - r.right - 4);
        var iconCenterFromRight = window.innerWidth - (r.left + r.width / 2);
        arrow = Math.min(Math.max(iconCenterFromRight - right - 6, 12), bubble.offsetWidth - 24);
      }
      bubble.style.top = top + 'px';
      bubble.style.right = right + 'px';
      bubble.style.setProperty('--pkcard-added-arrow', arrow + 'px');
      requestAnimationFrame(function () { bubble.classList.add('is-visible'); });

      // Hide after 3 seconds, on a tap outside, or on scroll
      var timer = null;
      var onOutside = function (e) { if (!bubble.contains(e.target)) hide(); };
      var hide = function () {
        clearTimeout(timer);
        document.removeEventListener('pointerdown', onOutside, true);
        window.removeEventListener('scroll', hide);
        bubble.classList.remove('is-visible');
        setTimeout(function () { bubble.remove(); }, 300);
        if (hideBubble === hide) hideBubble = null;
      };
      hideBubble = hide;
      timer = setTimeout(hide, 3000);
      setTimeout(function () {
        document.addEventListener('pointerdown', onOutside, true);
        window.addEventListener('scroll', hide, { passive: true });
      }, 0);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pkcard-add]');
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      e.preventDefault();
      var icon = btn.innerHTML;
      var card = btn.closest('.pkcard') || btn;
      var cardStyle = getComputedStyle(card);
      var dotColor = cardStyle.getPropertyValue('--pkcard-accent').trim() || '#e31d93';
      var info = {
        title: btn.dataset.pkcardTitle || '',
        meta: (btn.dataset.pkcardVariant ? btn.dataset.pkcardVariant + ' · ' : '') + 'Qty 1',
        price: btn.dataset.pkcardPrice || '',
        image: btn.dataset.pkcardImage || '',
        soft: cardStyle.getPropertyValue('--pkcard-bg').trim()
      };
      btn.setAttribute('aria-busy', 'true');
      addToCart(Number(btn.dataset.pkcardAdd))
        .then(function () {
          btn.classList.add('is-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
          try {
            flyToCart(btn, dotColor, function () { showAddedBubble(info); });
          } catch (err) { /* animation is optional */ }
          refreshCartCount();
        })
        .catch(function () {})
        .finally(function () { setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = icon; btn.removeAttribute('aria-busy'); }, 1500); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
